import React, { useState, useEffect, useRef } from "react";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";

import { Form, Row } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { Button, Loader } from "../../components";
import doubleArrow from "../../assets/images/double-arrow.svg";
import _, { min, range } from "lodash";
import moment from "moment";
import styled from "styled-components";
import "../../css/bootstrap-datepicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getYear, getMonth } from "date-fns";
import "./security-details.scss";
import "./formFile.scss";
import {
  numOnly,
  noNum,
  toCapitalize,
  allowOnlyAlphabets,
} from "../Landing/utils";
import { lowerCase } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  clearRegionDetails,
  clearRegionDetailsHdfcAppointee,
  clearRegionDetailsHdfcNominee,
  getRegion,
  getRegionHdfcAppointee,
  getRegionHdfcNominee,
  getRelationDetails,
  hdfcRegionDetailsNominee,
} from "./details.slice";
import { onlyOneSpace } from "./utils";
const Options = [
  { option: "Yes", id: "Yes", value: "Y" },
  { option: "No", id: "No", value: "N" },
];
const AddresOptions = [
  { option: "Proposer", id: "Proposer", value: "Proposer" },
  { option: "Nominee", id: "Nominee", value: "Nominee" },
];
const validationSchema = (hdfc) =>
  yup.object({
    NomineeName: yup
      .string()
      .required("Full name is required")
      .matches(
        /^[a-zA-Z\.\'\-]{1,50}(?: [a-zA-Z\.\'\-]{1,50})+$/,
        "Please enter a valid full name"
      )
      // .matches(/^[a-zA-Z ]*$/, "Please enter a valid first name")
      .label("Full Name"),
    NomineeAge: yup
      .string()
      .required("Please enter your age")
      .min(2, "Please enter a valid age")
      .max(2, "Please enter a valid age"),
    // nomineeRelation: yup.string().required("Please select relation"),
    ApointeeName: yup.string().when("NomineeAge", {
      is: (val) => val < 18,
      then: yup
        .string()
        .required("Appointee Full Name is required")
        .matches(
          /^[a-zA-Z\.\'\-]{1,50}(?: [a-zA-Z\.\'\-]{1,50})+$/,
          "Please enter a valid full name"
        ),
    }),
    // appointeeRelation: yup.string().when("NomineeAge", {
    //   is: (val) => val < 18,
    //   then: yup.string().required("Appointee Relation is required"),
    // }),
    RiskCoverAddress1: yup.string().when("IsPropertyAddressSame", {
      is: "N",
      then: yup.string().required("Please enter your address"),
    }),
    RiskCoverAddress2: yup.string().when("IsPropertyAddressSame", {
      is: "N",
      then: yup.string().required("Please enter your address"),
    }),
    RiskCoverPincode: yup.string().when("IsPropertyAddressSame", {
      is: "N",
      then: yup
        .string()
        .required("Please enter your pincode")
        .matches(/^[1-9]{1}[0-9]{5}$/, "Please enter a valid pincode"),
    }),

    RiskCoverCityName: yup.string().when("IsPropertyAddressSame", {
      is: "N",
      then: yup.string().required("Please enter your city"),
    }),
    ApointeePincode: yup.string().when("IsApointeeAddressSameAsProposerr", {
      is: null,
      then: yup
        .string()
        .required("Please enter your pincode")
        .matches(/^[1-9]{1}[0-9]{5}$/, "Please enter a valid pincode"),
    }),
    ApointeeCityName: yup.string().when("IsApointeeAddressSameAsProposerr", {
      is: null,
      then: yup.string().required("Please enter your city"),
    }),
    ApointeePincode: yup.string().when("IsApointeeAddressSameAsProposerr", {
      is: null,
      then: yup
        .string()
        .required("Please enter your pincode")
        .matches(/^[1-9]{1}[0-9]{5}$/, "Please enter a valid pincode"),
    }),
    ApointeeAddress1: yup.string().when("IsApointeeAddressSameAsProposerr", {
      is: null,
      then: yup.string().required("Please enter your Address"),
    }),
    ApointeeAddress2: yup.string().when("IsApointeeAddressSameAsProposerr", {
      is: null,
      then: yup.string().required("Please enter your Address"),
    }),
    NomineeRelation: yup
      .string()
      .required("Please choose the correct value")
      .test(
        "NomineeRelation",
        "Please choose the correct value",
        (val) => val !== "Select"
      ),
    ApointeeRelationToNominee: yup
      .string()
      .when("IsApointeeAddressSameAsProposerr", {
        is: null,
        then: yup
          .string()
          .required("Please enter your Address")
          .test(
            "ApointeeRelationToNominee",
            "Please choose the correct value",
            (val) => val !== "Select"
          ),
      }),
  });
const NomineeDetails = ({ onSubmitNomineeHDFC, ...props }) => {
  const { handleSubmit, control, register, watch, reset, errors, setValue } =
    useForm({
      resolver: yupResolver(validationSchema(props.ic_id === 2)),
      mode: "onChange",
      reValidateMode: "onChange",
      defaultValues: props.formDataNominee || {},
    });
  const formDataNominee = props?.formDataNominee;
  console.log("formDataNominee", formDataNominee);
  const [relationData, setRelationData] = useState("NOMINEE_RELATION");
  const [pincode, setPincode] = useState(
    formDataNominee?.RiskCoverPincode || ""
  );
  const [pincodeAppintee, setPincodeAppintee] = useState(
    formDataNominee?.ApointeePincode || ""
  );
  console.log("errors", errors);
  const validate = props?.validate;
  const response = useSelector((state) => state.detailsform);
  const { data } = useSelector((state) => state.detailsform?.relation_responce);
  const dataNominee = useSelector(
    (state) => state?.detailsform?.hdfcRegionresponseNominee?.data
  );
  const dataAppointee = useSelector(
    (state) => state?.detailsform?.hdfcRegionresponseAppointee?.data
  );
  const NomineeAge = watch("NomineeAge");
  const IsPropertyAddressSame = watch("IsPropertyAddressSame");
  const IsApointeeAddressSameAsProposerr = watch(
    "IsApointeeAddressSameAsProposerr"
  );
  const realtionWithProposer = watch("realtionWithProposer");
  const dispatch = useDispatch();
  const addressRef = useRef();
  const attachRef = (ref) => {
    register(ref);
    addressRef.current = ref;
  };
  const pincodeErrorNominee = useSelector(
    (state) => state?.detailsform?.hdfcRegionresponseNominee?.message
  );
  const pincodeErrorAppointee = useSelector(
    (state) => state?.detailsform?.hdfcRegionresponseAppointee?.message
  );
  const { pincodeLoading } = useSelector((state) => state.detailsform);
  useEffect(() => {
    setPincode(formDataNominee?.RiskCoverPincode);
  }, [formDataNominee]);
  useEffect(() => {
    setPincodeAppintee(formDataNominee?.ApointeePincode);
  }, [formDataNominee]);
  useEffect(() => {
    if (relationData === "NOMINEE_RELATION") {
      let data = { masterKey: relationData };
      dispatch(getRelationDetails(data));
    }
  }, [relationData, dispatch]);

  //api call for state city------------------
  useEffect(() => {
    if (pincode?.length === 6) {
      let data = { pincode: pincode };
      dispatch(getRegionHdfcNominee(data));
    } else {
      dispatch(clearRegionDetailsHdfcNominee());
    }
  }, [pincode, dispatch]);

  useEffect(() => {
    if (pincodeAppintee?.length === 6) {
      let data = { pincode: pincodeAppintee };
      dispatch(getRegionHdfcAppointee(data));
    } else {
      dispatch(clearRegionDetailsHdfcAppointee());
    }
  }, [pincodeAppintee, dispatch]);

  return (
    <div style={{ width: "100%" }}>
      <Form
        noValidate
        className="personal-details-form"
        onSubmit={handleSubmit(onSubmitNomineeHDFC)}
      >
        {pincodeLoading == true && <Loader />}
        <Row xs={1} sm={1} md={1} lg={3} xl={3}>
          <div className="p-2">
            <Form.Group>
              <Form.Label style={{ fontSize: "14px" }}>Full Name</Form.Label>
              <Form.Control
                capitalize
                type="text"
                maxLength="60"
                minLength="3"
                required
                pattern="[^'\x22]+"
                title="Invalid input"
                name="NomineeName"
                ref={register}
                onKeyPress={onlyOneSpace}
                placeholder="Enter Full Name"
                onInput={allowOnlyAlphabets}
                onChange={(e) => {
                  toCapitalize(e);
                }}
              />

              {validate?.errors?.name || errors?.NomineeName ? (
                <p className="error">
                  {validate?.errors?.NomineeName ||
                    errors?.NomineeName?.message}
                </p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
          <div className="p-2">
            <Form.Group>
              <Form.Label style={{ fontSize: "14px" }}>Your Age</Form.Label>
              <Controller
                as={
                  <Form.Control
                    className="text-capitalize"
                    type="input"
                    placeholder="Enter Your Age"
                  />
                }
                required
                onInput={(e) => {
                  numOnly(e);
                }}
                onKeyPress={numOnly}
                name="NomineeAge"
                control={control}
              />

              {validate?.errors?.NomineeAge || errors?.NomineeAge ? (
                <p className="error">
                  {validate?.errors?.NomineeAge || errors?.NomineeAge?.message}
                </p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>

          <div className="p-2">
            <Form.Group
              controlId="exampleForm.SelectCustom"
              className="select-custom"
            >
              <Form.Label style={{ fontSize: "14px" }}>
                Relationship With Proposer
              </Form.Label>
              <Controller
                as={
                  <Form.Control as="select">
                    <option selected="true" disabled hidden>
                      Select
                    </option>
                    {data?.data.map((val) => {
                      return <option value={val.Data}>{val.Data}</option>;
                    })}
                  </Form.Control>
                }
                required
                name="NomineeRelation"
                control={control}
              />
              {errors?.NomineeRelation ? (
                <p className="error">
                  {validate?.errors?.NomineeRelation ||
                    errors?.NomineeRelation?.message}
                </p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
        </Row>

        <div className="form-group p-2">
          <label style={{ fontSize: "14px" }}>
            {" "}
            Is the address is same as proposer?
          </label>

          <div>
            {Options.map((item) => (
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  className="custom-control-input"
                  id={item?.option}
                  name="IsPropertyAddressSame"
                  value={item?.value}
                  ref={attachRef}
                  defaultChecked
                />
                <label className="custom-control-label" for={item?.id}>
                  {item?.option || "-"}
                </label>
              </div>
            ))}
          </div>
          <br />
        </div>

        {IsPropertyAddressSame === "N" ? (
          <>
            <b
              style={{
                marginTop: "7px",
                marginBottom: "10px",
                fontSize: "20px",
              }}
            >
              Address Of Nominee
            </b>
            <br />
            <br />
            <Row xs={1} sm={1} md={1} lg={3} xl={3}>
              <div className="px-2" style={{ padding: "0 10px" }}>
                <Form.Group>
                  <Form.Label style={{ fontSize: "14px" }}>
                    Address line1
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength="90"
                    minLength="3"
                    required
                    pattern="[^'\x22]+"
                    title="Invalid input"
                    name="RiskCoverAddress1"
                    ref={register}
                  />
                  {validate?.errors?.RiskCoverAddress1 ||
                  errors?.RiskCoverAddress1 ? (
                    <p className="error">
                      {validate?.errors?.RiskCoverAddress1 ||
                        errors?.RiskCoverAddress1?.message}
                    </p>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </div>
              <div className="px-2" style={{ padding: "0 10px" }}>
                <Form.Group>
                  <Form.Label style={{ fontSize: "14px" }}>
                    Address line2
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength="90"
                    minLength="3"
                    required
                    pattern="[^'\x22]+"
                    title="Invalid input"
                    name="RiskCoverAddress2"
                    ref={register}
                  />
                  {validate?.errors?.RiskCoverAddress2 ||
                  errors?.RiskCoverAddress2 ? (
                    <p className="error">
                      {validate?.errors?.RiskCoverAddress2 ||
                        errors?.RiskCoverAddress2?.message}
                    </p>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </div>

              <div className="px-2" style={{ padding: "0 10px" }}>
                <Form.Group>
                  <Form.Label style={{ fontSize: "14px" }}>Pin-code</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    minlength="6"
                    name="RiskCoverPincode"
                    maxlength="6"
                    pattern="[0-9]{6}"
                    title="Pincode must be in number"
                    // value={pinCode}
                    onKeyPress={numOnly}
                    ref={register}
                    onChange={(selected) => {
                      setPincode(selected.target.value);
                      // props.getPincodeNominee(selected.target.value);
                      return selected.target.value;
                    }}
                    // defaultValue={formData.pincode}
                  />
                  {errors?.RiskCoverPincode || pincodeErrorNominee ? (
                    <p className="error">
                      {errors?.RiskCoverPincode?.message || pincodeErrorNominee}
                    </p>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </div>
              <div className="px-2" style={{ padding: "0 10px" }}>
                <Form.Group
                  controlId="exampleForm.SelectCustom"
                  className="select-custom"
                >
                  <Form.Label style={{ fontSize: "14px" }}>State</Form.Label>
                  <Form.Control
                    name="RiskCoverStateName"
                    as="select"
                    required
                    ref={register}
                    value={dataNominee?.data?.stateName || ""}
                  >
                    <option disable selected="true">
                      {dataNominee?.data?.stateName || "N/A"}
                    </option>
                  </Form.Control>

                  {errors?.RiskCoverCityName ? (
                    <>
                      {dataNominee?.data?.stateName ? (
                        <></>
                      ) : (
                        <p className="error">{"Please enter your State"}</p>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </div>
              <div className="px-2" style={{ padding: "0 10px" }}>
                <Form.Group controlId="exampleForm.SelectCustom">
                  <Form.Label style={{ fontSize: "14px" }}>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="RiskCoverCityName"
                    ref={register}
                    value={dataNominee?.data?.cityName || ""}
                    required
                  ></Form.Control>
                  {errors?.RiskCoverCityName ? (
                    <>
                      {dataNominee?.data?.cityName ? (
                        <></>
                      ) : (
                        <p className="error">
                          {errors?.RiskCoverCityName.message ||
                            "Please enter your city"}
                        </p>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </div>
            </Row>
          </>
        ) : (
          <Row xs={1} sm={1} md={1} lg={3} xl={6}></Row>
        )}

        {NomineeAge < 18 && (
          <div style={{ marginTop: "20px" }}>
            <strong>Note:</strong>
            <span>
              {" "}
              Since the above nominee is Minor, please provide the detail of an
              appointee
            </span>
            <Row xs={1} sm={1} md={1} lg={3} xl={3}>
              <div className="p-2">
                <Form.Group>
                  <Form.Label style={{ fontSize: "14px" }}>
                    Full Name
                  </Form.Label>
                  <Form.Control
                    capitalize
                    type="text"
                    maxLength="60"
                    minLength="3"
                    required
                    pattern="[^'\x22]+"
                    title="Invalid input"
                    name="ApointeeName"
                    onKeyPress={onlyOneSpace}
                    ref={register}
                    placeholder="Enter Full Name"
                    onInput={allowOnlyAlphabets}
                    onChange={(e) => {
                      toCapitalize(e);
                    }}
                  />
                  {/* <Controller
                  as={
                    <Form.Control
                      className="text-capitalize"
                      type="input"
                      placeholder="Name of Appointee"
                    />
                  }
                  required
              onInput={allowOnlyAlphabets}
              onChange={(e) => {
                toCapitalize(e);
              }}
                  name="ApointeeName"
                  control={control}
                /> */}
                  {validate?.errors?.ApointeeName || errors?.ApointeeName ? (
                    <p className="error">
                      {validate?.errors?.ApointeeName ||
                        errors?.ApointeeName?.message}
                    </p>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </div>

              <div className="p-2">
                <Form.Group
                  controlId="exampleForm.SelectCustom"
                  className="select-custom"
                >
                  <Form.Label style={{ fontSize: "14px" }}>
                    Relationship With Nominee
                  </Form.Label>
                  <Controller
                    as={
                      <Form.Control as="select">
                        <option selected="true" disabled hidden>
                          Select
                        </option>
                        {data?.data.map((val) => {
                          return <option value={val.Data}>{val.Data}</option>;
                        })}
                      </Form.Control>
                    }
                    required
                    name="ApointeeRelationToNominee"
                    control={control}
                  />
                  {errors?.ApointeeRelationToNominee ? (
                    <p className="error">
                      {validate?.errors?.ApointeeRelationToNominee ||
                        errors?.ApointeeRelationToNominee?.message}
                    </p>
                  ) : (
                    ""
                  )}
                  {/* {validate?.errors?.appointeeRelation ||
                errors?.appointeeRelation ? (
                  <p className="error">
                    {validate?.errors?.appointeeRelation ||
                      errors?.appointeeRelation?.message}
                  </p>
                ) : (
                  ""
                )} */}
                </Form.Group>
              </div>
            </Row>
            <b
              style={{
                marginTop: "7px",
                marginBottom: "10px",
                fontSize: "20px",
              }}
            >
              Address Of Appointee
            </b>
            <br />
            {/* <Row xs={1} sm={1} md={1} lg={3} xl={3}> */}
            <div className="form-group p-2">
              <label style={{ fontSize: "14px" }}> Address Same as</label>

              <div>
                {AddresOptions.map((item) => (
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id={item?.option}
                      name="IsApointeeAddressSameAsProposerr"
                      value={item?.value}
                      ref={attachRef}
                    />
                    <label className="custom-control-label" for={item?.id}>
                      {item?.option || "-"}
                    </label>
                  </div>
                ))}
              </div>
              <br />
            </div>
            {/* </Row> */}
            {IsApointeeAddressSameAsProposerr == null && (
              <Row xs={1} sm={1} md={1} lg={3} xl={3}>
                <div className="px-2" style={{ padding: "0 10px" }}>
                  <Form.Group>
                    <Form.Label style={{ fontSize: "14px" }}>
                      Address line1
                    </Form.Label>
                    <Form.Control
                      type="text"
                      maxLength="90"
                      minLength="3"
                      required
                      pattern="[^'\x22]+"
                      title="Invalid input"
                      name="ApointeeAddress1"
                      ref={register}
                    />
                    {validate?.errors?.ApointeeAddress1 ||
                    errors?.ApointeeAddress1 ? (
                      <p className="error">
                        {validate?.errors?.ApointeeAddress1 ||
                          errors?.ApointeeAddress1?.message}
                      </p>
                    ) : (
                      ""
                    )}
                  </Form.Group>
                </div>
                <div className="px-2" style={{ padding: "0 10px" }}>
                  <Form.Group>
                    <Form.Label style={{ fontSize: "14px" }}>
                      Address line2
                    </Form.Label>
                    <Form.Control
                      type="text"
                      maxLength="90"
                      minLength="3"
                      required
                      pattern="[^'\x22]+"
                      title="Invalid input"
                      name="ApointeeAddress2"
                      ref={register}
                    />
                    {validate?.errors?.ApointeeAddress2 ||
                    errors?.ApointeeAddress2 ? (
                      <p className="error">
                        {validate?.errors?.ApointeeAddress2 ||
                          errors?.ApointeeAddress2?.message}
                      </p>
                    ) : (
                      ""
                    )}
                  </Form.Group>
                </div>

                <div className="px-2" style={{ padding: "0 10px" }}>
                  <Form.Group>
                    <Form.Label style={{ fontSize: "14px" }}>
                      Pin-code
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      minlength="6"
                      name="ApointeePincode"
                      maxlength="6"
                      pattern="[0-9]{6}"
                      title="Pincode must be in number"
                      // value={pinCode}
                      onKeyPress={numOnly}
                      ref={register}
                      onChange={(selected) => {
                        setPincodeAppintee(selected.target.value);
                        // getPincode(selected.target.value);
                        return selected.target.value;
                      }}
                      // defaultValue={formData.pincode}
                    />
                    {errors?.ApointeePincode || pincodeErrorAppointee ? (
                      <p className="error">
                        {errors?.ApointeePincode?.message ||
                          pincodeErrorAppointee}
                      </p>
                    ) : (
                      ""
                    )}
                  </Form.Group>
                </div>
                <div className="px-2" style={{ padding: "0 10px" }}>
                  <Form.Group
                    controlId="exampleForm.SelectCustom"
                    className="select-custom"
                  >
                    <Form.Label style={{ fontSize: "14px" }}>State</Form.Label>
                    <Form.Control
                      name="ApointeeStateName"
                      as="select"
                      required
                      ref={register}
                      value={dataAppointee?.data?.stateName || ""}
                    >
                      <option disable selected="true">
                        {dataAppointee?.data?.stateName ||
                          // formDataNominee?.ApointeeStateName ||
                          "N/A"}
                      </option>
                    </Form.Control>
                    {errors?.ApointeeCityName ? (
                      <>
                        {dataAppointee?.data?.stateName ? (
                          <></>
                        ) : (
                          <p className="error">{"Please enter your State"}</p>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </Form.Group>
                </div>
                <div className="px-2" style={{ padding: "0 10px" }}>
                  <Form.Group controlId="exampleForm.SelectCustom">
                    <Form.Label style={{ fontSize: "14px" }}>City</Form.Label>
                    <Form.Control
                      type="text"
                      name="ApointeeCityName"
                      ref={register}
                      value={
                        dataAppointee?.data?.cityName ||
                        // formDataNominee?.ApointeeCityName ||
                        ""
                      }
                      required
                    ></Form.Control>
                    {errors?.ApointeeCityName ? (
                      <>
                        {dataAppointee?.data?.cityName ? (
                          <></>
                        ) : (
                          <p className="error">
                            {errors?.ApointeeCityName.message ||
                              "Please enter your city"}
                          </p>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </Form.Group>
                </div>
              </Row>
            )}
          </div>
        )}
        <Row style={{ justifyContent: "center", marginTop: "10px" }}>
          <Button
            style={{
              fontWeight: "400",
              fontSize: "15px",
              borderRadius: "0.25rem",
              height: "35px",
              paddingTop: "5px",
            }}
          >
            Proceed To Security Details
          </Button>
        </Row>
      </Form>
    </div>
  );
};
const Border = styled.span`
  .react-datepicker__input-container input {
    border: 1px solid #ced4da;
  }
  @-moz-document url-prefix() {
    .date {
      border: 1px solid #ced4da;
      z-index: 0;
    }
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .date {
      border: 1px solid #ced4da;
      padding: 7px !important;
      z-index: 0;
    }
  }
`;
const FormTag = styled(Form)`
  padding: 15px;
  @media (max-width: 480px) {
    padding: 5px;
    padding-left: 10px !important;
  }
`;

export default NomineeDetails;
